import {gql} from '@apollo/client'

export default gql`
mutation AddSurveyToUser($userId: ID!, $title: String, $survey_type: String, $trial_type:String, $survey_language:String) {
  addSurveyToUser(userId: $userId, title: $title, survey_type: $survey_type, trial_type:$trial_type,survey_language:$survey_language) {
    id
  }
}
`